import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List, ListItem } from '@dbk/ui-list';
import { Radio } from '@dbk/ui-forms';
import { createContainer } from '@dbk-legacy/muster/react';
import languageData from '../../data/language-list.json';
import Button from '@dbk/ui-buttons';
import BlurModal from '../../components/common/blur-modal';
import ScrollableLayout from '../../components/common/scrollable-layout';
import Spinner from '@dbk/ui-spinner';

class ProfileChangeLanguage extends Component {
  state = {
    showModal: false,
    selectLangObj: [],
  };

  handlePress = (languageObj, destLanguage) => {
    if (languageObj.language != destLanguage) {
      this.setState({ showModal: true, selectLangObj: languageObj });
    }
  };
  renderConfirmModal() {
    const { messages } = this.props.i18n;
    const confirmText = messages['app.profile.changeLanguage.confirmText'];
    const cancelText = messages['app.profile.changeLanguage.cancelText'];
    return (
      <div className="timeout-modal">
        <div className="row">
          <div className="small-12 text-center">
            <div>
              <h2>{messages['app.common.pageTitle.changeLanguage']}</h2>
              <div>{messages['app.profile.changeLanguage.confirmMsg']}</div>
              <div className="row">
                <div className="column pad-top-20 small-push-1">
                  <div className="row">
                    <div id="btn_confirm_langugage_selection" className="column small-6">
                      <Button testID="btn_confirm_langugage_selection_id"
                        size="normal"
                        onClick={this.pressedConfirm}
                      >
                        {confirmText}
                      </Button>
                    </div>
                    <div className="column small-6">
                      <Button
                        testID="btn_language_cancel_profileLanguageOptions_test"
                        size="normal"
                        onClick={this.pressedCancel}
                      >
                        {cancelText}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  pressedConfirm = () => {
    this.setState({ showModal: false });
    const languageObj = this.state.selectLangObj;
    const {
      languages,
      changePage,
      i18n: { messages },
    } = this.props;
    languages.saveLanguage({ languageObj });
    // changePage({ pathname: '/profile' });
    // alert(messages['app.profile.language.changeLanguageMsg']);
  };

  pressedCancel = () => this.setState({ showModal: false });

  renderListItems = (item, selectedLanguage, key) => {
    const { auth: { settingsDisabled } } = this.props;
    return (
      <ListItem
        testID="list_languageSelection_profileLanguageOption_test"
        onClick={() => !settingsDisabled ? this.handlePress(item, selectedLanguage) : null }
        className="consolidation__list-item" >
        <span id={`language_selection_radio_${key}`}>
          <Radio
            className="profile__radio-button"
            checked={selectedLanguage === item.language}
            disabled={settingsDisabled} />
          <span className="currency__list-item">{item.language}</span>
        </span>
      </ListItem>
    )
  };

  render() {
    const languageList = languageData.languageList;
    const {
      i18n: { messages },
      languages: { destLanguage, loadingLanguage },
    } = this.props;
    const selectedLanguage = destLanguage || 'English';

    return (
      <ScrollableLayout
        testID="Profile-view"
        body={
          <div className="row consolidation">
           {loadingLanguage && <div className="center-content pad-top-15"><Spinner /></div>}
            <div className="columns small-12 large-12  profile-container">
              <div className="profile-container__title">
                <h2>{messages['app.common.pageTitle.changeLanguage']}</h2>
              </div>
              <div className="profile__content">
                <p className="profile__content-info">
                  {messages['app.profile.languageHead']}
                </p>
                <div>
                  <div className="consolidation__items-wrapper">
                    <List className="profile__list" fullWidth>
                      {languageList.map((e,key) => this.renderListItems(e, selectedLanguage, key))}
                    </List>
                  </div>
                </div>
              </div>
            </div>
            <BlurModal
              visible={this.state.showModal}
              doneVisible={false}
              title={messages['app.auth.logout.header']}
              onDone={this.pressedCancel}
            >
              {this.renderConfirmModal()}
            </BlurModal>
          </div>
        }
      />
    );
  }
}

export default createContainer({
  $queries: {
    auth: {
      destinationCurrency: true,
      settingsDisabled: true
    },
    languages: {
      saveLanguage: { $call: 'saveLanguage' },
      destLanguage: true,
      destLanguageCode: true,
      loadingLanguage: true
    },
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
  },
})(ProfileChangeLanguage);
